import React from 'react';
import './PopupModal.css';

interface PopupModalProps {
    bgImage: string;
    title: string;
    firstText: string;
    secondText: string;
    onClose: () => void;
    onPrevious: () => void;
    onNext: () => void;
}

export default function PopupModal({
    bgImage,
    title,
    firstText,
    secondText,
    onClose,
    onPrevious,
    onNext,
}: PopupModalProps) {
    return (
        <div
            className="ff-modal"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="ff-modal-top-row">
                <button
                    className="ff-modal-close-btn"
                    onClick={onClose}
                    type="button"
                >
                    <span>CLOSE</span>
                    <span className="ff-modal-close-icon">&times;</span>
                </button>
            </div>

            <div className="ff-modal-body">
                <div className="ff-modal-content">
                    <div
                        className="ff-modal-title"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <div
                        className="ff-modal-first-text"
                        dangerouslySetInnerHTML={{ __html: firstText }}
                    />
                    <div className="ff-modal-separator" />
                    <div
                        className="ff-modal-second-text"
                        dangerouslySetInnerHTML={{ __html: secondText }}
                    />
                </div>
            </div>

            <div className="ff-modal-bottom-row">
                <button
                    className="ff-modal-nav-btn"
                    onClick={onPrevious}
                    type="button"
                >
                    <span className="ff-modal-arrow-box">&#8592;</span>
                    <span>Previous</span>
                </button>
                <button
                    className="ff-modal-nav-btn"
                    onClick={onNext}
                    type="button"
                >
                    <span>NEXT</span>
                    <span className="ff-modal-arrow-box">&#8594;</span>
                </button>
            </div>
        </div>
    );
}
